import React, { useState, createContext, ReactNode } from "react";

interface LoanInfo {
  amount: number;
  monthlyPayment: number | string;
  months: number;
  nominalInterest: number | string;
  effectiveInterest: number | string;
  nominalEffInterest: number;
  startupFee: number | string;
  monthlyFee: number | string;
  totalCost: number | string;
  monthlyInsuranceCost: number | string;
}

interface ContextProps {
  flowId?: string | undefined;
  showButtons: boolean;
  setShowButtons: React.Dispatch<React.SetStateAction<boolean>>;
  loaded: boolean;
  setLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  loanInfo: LoanInfo;
  setLoanInfo: React.Dispatch<React.SetStateAction<LoanInfo>>;
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  id: string | undefined;
  setId: React.Dispatch<React.SetStateAction<string | undefined>>;
  ipAddress: string | undefined;
  setIpAddress: React.Dispatch<React.SetStateAction<string | undefined>>;
  consentList: any[];
  setConsentList: React.Dispatch<React.SetStateAction<any[]>>;
  isCheck: any[];
  setIsCheck: React.Dispatch<React.SetStateAction<any[]>>;
  newValues: any | undefined;
  setNewValues: React.Dispatch<React.SetStateAction<any | undefined>>;
  consent: any | undefined;
  setConsent: React.Dispatch<React.SetStateAction<any | undefined>>;
  showInsurance: any | undefined;
  setShowInsurance: React.Dispatch<React.SetStateAction<any | undefined>>;
  monthlyInsuranceCost: number;
  setMonthlyInsuranceCost: React.Dispatch<React.SetStateAction<number>>;
  showPopup: any | undefined;
  setShowPopup: React.Dispatch<React.SetStateAction<any | undefined>>;
}

export const Context = createContext<ContextProps | undefined>(undefined);

interface ContextProviderProps {
  children: ReactNode;
}

export const ContextProvider: React.FC<ContextProviderProps> = (props) => {
  const [loaded, setLoaded] = useState<boolean>(true);
  const [showButtons, setShowButtons] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [id, setId] = useState<string | undefined>(undefined);
  const [ipAddress, setIpAddress] = useState<string | undefined>(undefined);
  const [newValues, setNewValues] = useState<any | undefined>(undefined);
  const [consentList, setConsentList] = useState<any[]>([]);
  const [isCheck, setIsCheck] = useState<any[]>([]);
  const [consent, setConsent] = useState<any | undefined>(undefined);
  const [showPopup, setShowPopup] = useState<any | undefined>(undefined);
  const [showInsurance, setShowInsurance] = useState<any | undefined>(undefined);
  const [monthlyInsuranceCost, setMonthlyInsuranceCost] = useState<number>(0);
  const [loanInfo, setLoanInfo] = useState<LoanInfo>({
    amount: 12000,
    monthlyPayment: 0,
    months: 57,
    nominalInterest: 0,
    effectiveInterest: 0,
    nominalEffInterest: 0,
    startupFee: 0,
    monthlyFee: 0,
    totalCost: 0,
    monthlyInsuranceCost: 0,
  });

  const contextValue: ContextProps = {
    showButtons,
    setShowButtons,
    loaded,
    setLoaded,
    loanInfo,
    setLoanInfo,
    activeStep,
    setActiveStep,
    id,
    setId,
    ipAddress,
    setIpAddress,
    consentList,
    setConsentList,
    isCheck,
    setIsCheck,
    newValues,
    setNewValues,
    consent,
    setConsent,
    showInsurance,
    setShowInsurance,
    monthlyInsuranceCost,
    setMonthlyInsuranceCost,
    showPopup,
    setShowPopup,
  };

  return (
    <Context.Provider value={contextValue}>{props.children}</Context.Provider>
  );
};